import React from "react";
import styled from "styled-components";
import { BetaMasthead } from "../../../components/BetaMasthead";
import { z } from "zod";
import { BetaRegistrationMastheadBladeSchema, } from "../../../schemas/BetaRegistrationMasthead";
import { BetaKeyModule } from "../../../components/BetaKeyModule";
import { BetaKeyModulePlatform } from "../../../components/BetaKeyModule/components/BetaKeyModule";
import { useBetaHubRouter } from "../../../functional/hooks/useBetaHubRouter";
import { BetaLoader } from "../../../components/BetaLoader";
export const BetaKeyDisplayMastheadContractSchema = BetaRegistrationMastheadBladeSchema.extend({
    type: z.literal("betaKeyDisplayMasthead"),
});
const XBOX_REDIRECT_URL = "https://support.xbox.com/help/subscriptions-billing/redeem-codes-gifting/redeem-prepaid-codes";
const PLAYSTATION_REDIRECT_URL = "https://www.playstation.com/support/store/redeem-ps-store-voucher-code/";
const getButtonStyle = (platform = "", betaKeyRedemption) => {
    const { xboxKeyHeader = "", psBetaKeyHeader = "", xboxRedeemButtonText = "", psRedeemButtonText = "", } = betaKeyRedemption;
    if (platform.includes("PLAYSTATION")) {
        return {
            buttonStyle: BetaKeyModulePlatform.PLAYSTATION,
            description: psBetaKeyHeader,
            buttonTitle: psRedeemButtonText,
            buttonUrl: PLAYSTATION_REDIRECT_URL,
        };
    }
    return {
        buttonStyle: BetaKeyModulePlatform.XBOX,
        description: xboxKeyHeader,
        buttonTitle: xboxRedeemButtonText,
        buttonUrl: XBOX_REDIRECT_URL,
    };
};
const _BetaKeyDisplayMasthead = ({ header, className, backdrop, buttons, gameIcon, campaignID, betaKeyRedemption, ...bladeProps }) => {
    const { isLoading, betaKey, isAllowedRoute } = useBetaHubRouter({ campaignID });
    if (!betaKeyRedemption) {
        return null;
    }
    const { copySuccessText } = betaKeyRedemption;
    const { description, buttonTitle, buttonUrl, buttonStyle } = getButtonStyle(betaKey?.platform, betaKeyRedemption);
    const betaKeyCode = process.env.STORYBOOK ? "MDGMW-JHJJC-D9KM4-7C2K7-T644Z" : betaKey?.code || "";
    return (React.createElement(BetaLoader, { isLoading: isLoading, isAllowedRoute: isAllowedRoute, palette: "palette3" },
        React.createElement(BetaMasthead, { header: header, backdrop: backdrop, gameIcon: gameIcon, ...bladeProps },
            React.createElement(BetaKeyModule, { description: description, betaKey: betaKeyCode, copySuccessText: copySuccessText ?? "", button: {
                    style: buttonStyle,
                    title: buttonTitle,
                    redirectUrl: buttonUrl,
                } }))));
};
export const BetaKeyDisplayMasthead = styled(_BetaKeyDisplayMasthead) ``;
//# sourceMappingURL=BetaKeyDisplayMasthead.js.map